import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5475" data-mp="3ntzkuaasqnh9">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5476" data-mp="3rrnfdc8kue8m">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5477" data-mp="obzt8lbwh3dc">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5478" data-mp="fccte3ytk5me">
              <XIcon className="w-6 h-6" data-id="element-5479" data-mp="2v5txrgw9sme9" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5480" data-mp="303vdpsyeg5li">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5481" data-mp="2n7lbhh3qjvvn"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5482" data-mp="318nzw0i7di9q">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5483" data-mp="3fyv9rru59syt">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5484" data-mp="3ayqs3yhi2s70" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5485" data-mp="3rzuyraqir57z">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5486" data-mp="aibsrvlv94vs">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5487" data-mp="akerr54zy8cn">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5488" data-mp="ejxbhxl30ddw" />
          <div className="hidden md:block" data-id="element-5489" data-mp="th65kz1rrv9b">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5490" data-mp="tg4w2z0ejgtp">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5491" data-mp="1cfj1cphtlsk3">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5492" data-mp="yo4kao7h41fo">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5493" data-mp="1vbiysftkhob2">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5494" data-mp="1hf5fd15h3cty">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5495" data-mp="1tsr4rmjj8ojo">
        <div className="md:col-span-7" data-id="element-5496" data-mp="1ymbrujjl7y43">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4 text-center md:text-left" data-id="element-5497" data-mp="1ktvy69cktcfu">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight text-center md:text-left" data-id="element-5498" data-mp="2dib9olwi1cmf">
            Leer Je Hond Écht Begrijpen - Zodat Je Weet Wat Hij Denkt, Voelt en
            Wilt
          </h1>
          <div className="md:hidden mb-6" data-id="element-5499" data-mp="23kwwqw9sb5yv">
            <img src="https://cdn.magicpatterns.com/uploads/qnzT9c8MEjsZMbSpGR8q95/MCC_webinar_preview.png" alt="Webinar preview: Communiceren met je Hond" className="w-full rounded-2xl shadow-lg" data-id="element-5500" data-mp="23m7y6pfrc1mt" />
          </div>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5501" data-mp="x4uka6kz5936">
            Ja, ik wil mijn hond begrijpen →
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5502" data-mp="ykoudifjrrt5">
            <div className="flex -space-x-3" data-id="element-5503" data-mp="tn6v6jrc0qyc">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5504" data-mp="tkaxmwjec4af" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5505" data-mp="fne5mrrjkgry" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5506" data-mp="3j934nteze1to" />
            </div>
            <div data-id="element-5507" data-mp="1n6qbxxgrlze5">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5508" data-mp="1n683m2gtvupv">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5509" data-mp="1s0cgf2crywyv">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5510" data-mp="zac8eumz93rs">
            Ontdek in dit gratis 90-minuten webinar hoe je de hondentaal leert
            lezen - zodat je je hond beter begrijpt en weet hoe je moet reageren
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5511" data-mp="197qm4mhinege">
            {['Hoe je je hond beter leert begrijpen - ook als je al jaren honden hebt', 'De hondentaal leren lezen - zodat je ziet wat hij denkt, voelt en wilt', 'Hoe je angst, stress en onzekerheid herkent - voordat het escaleert', 'Waarom je hond soms niet luistert - en wat hij je eigenlijk probeert te vertellen', 'De 3 kernbehoeften van elke hond - en hoe deze alles verklaren', 'Hoe je de signalen herkent die je nu mist - zodat je weet hoe je moet reageren'].map((item, i) => <li key={i} className="flex items-start" data-id="element-5512" data-mp="47im3far4cdu" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5513" data-mp="3vev4tyra8xvv" />
                <span className="text-gray-700 font-medium" data-id="element-5514" data-mp="3qhcuq51j4cma">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5515" data-mp="3lgp6ts8lkbwa">
            <div className="flex -space-x-3" data-id="element-5516" data-mp="3hfvf0ns1acy4">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5517" data-mp="3hgoqg21xtqml" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5518" data-mp="1apyojzfdwva8" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5519" data-mp="oiwjomynfn6p" />
            </div>
            <div data-id="element-5520" data-mp="tlqbqjmov2l">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5521" data-mp="t2786i8s0mz">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5522" data-mp="4vykdhp0j4jj">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5523" data-mp="3n362qayrprww">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5524" data-mp="3s0xwlaiz3o3q">
            <div className="flex justify-center items-center w-full" data-id="element-5525" data-mp="1l96vq1sohwq0">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5526" data-mp="1l7vt45ayyv0h"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5527" data-mp="3tjepji5w08r8">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5528" data-mp="3oiqricj8qrni">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5529" data-mp="3oklahlayc9oy">
            Leer de hondentaal in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5530" data-mp="2ar5d5jdurl9">
            <div className="flex flex-col items-center" data-id="element-5531" data-mp="296atfx2j8ne">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5532" data-mp="2929rshxwp5lo" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5533" data-mp="1pj9ypq6xvio1">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5534" data-mp="1kkoxpojv4uyj">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5535" data-mp="1aoc1ok0ui50m">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5536" data-mp="1apwx0buzhrzj" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5537" data-mp="1ylrkk3iom9ai">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5538" data-mp="1yjoksrrq91sl">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5539" data-mp="2r3n4lslbaydx">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5540" data-mp="2mbdfges0u2cp" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5541" data-mp="2ynxo9o30ffjn">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5542" data-mp="33jd06ahgj1df">
                Leer in 90 minuten de hondentaal begrijpen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5543" data-mp="3djdknzr2bnj7">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5544" data-mp="3r97det5oury7">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5545" data-mp="47lzdgt1t5w">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5546" data-mp="5sgj334dc3r">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-5547" data-mp="3bl2idkx5nxq7" />
            <span className="italic" data-id="element-5548" data-mp="3bigbzom03o9k">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5549" data-mp="3ladoqzsnqoae">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5550" data-mp="3lbx6kutyp7ea">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5551" data-mp="3gim93kb1i2z1">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5552" data-mp="3pbz9167iu4um"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5553" data-mp="pcwps7i3zxul">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5554" data-mp="pezcoinytav3">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5555" data-mp="fm1z8qxtyc3c"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5556" data-mp="1r204ejpw0dza">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5557" data-mp="3n4ln9998li7y">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5558" data-mp="3e4yjwhwy62c9"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5559" data-mp="2lezu2kaxi16j">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5560" data-mp="2ggy7vqi7hlqu">
              <div className="flex items-center mb-4" data-id="element-5561" data-mp="vzp1q7xaes9i">
                <div className="flex text-green-500 mr-2" data-id="element-5562" data-mp="vyxjdyspar16">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5563" data-mp="110czrdjxo9d8" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5564" data-mp="19yyhx7lhtmdh">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5565" data-mp="19wm3v5iuvw5p">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5566" data-mp="i80p83j4m1s0">
                Mijn hele leven heb ik al honden maar altijd heb ik het gevoel
                gehad dat ik ze niet helemaal begreep. In korte tijd zoveel
                geleerd. Wat mij het meeste aanspreekt is dat het zonder
                commando's gaat maar via communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5567" data-mp="3uo4e21oq2fr3">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5568" data-mp="11smc2qvnh8b3">
              <div className="flex items-center mb-4" data-id="element-5569" data-mp="wv2w9mjb0nh1">
                <div className="flex text-green-500 mr-2" data-id="element-5570" data-mp="1bl0fdo2dmmzd">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5571" data-mp="16l5sdvlq2hjl" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5572" data-mp="iwwb96zgehys">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5573" data-mp="dxs1ae4pgg7e">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5574" data-mp="ry2qlcqd9mqg">
                Je leert in een hele fijne manier je hond begrijpen en anders
                naar je hond kijken. Amée is een zeer lieve vrouw met een hart
                voor honden en dat merk je zeer goed.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5575" data-mp="1z9jo24pc91rz">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5576" data-mp="2bsp1tyagetx4">
              <div className="flex items-center mb-4" data-id="element-5577" data-mp="2bqcc2yygff9i">
                <div className="flex text-green-500 mr-2" data-id="element-5578" data-mp="1wwhh8wv4vqhb">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5579" data-mp="21v1738culmey" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5580" data-mp="2pkvidlhir2x3">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5581" data-mp="2uinc8l1q4z3x">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5582" data-mp="2ksva95rap3pf">
                Ik heb er veel van opgestoken over de communicatie. Het valt
                echt op dat omdat ik zelf anders ben gaan opstellen, mijn honden
                nu veel rustiger communiceren met andere honden.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5583" data-mp="1d7okyrad231s">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5584" data-mp="18ff19szu9z7y">
              <div className="flex items-center mb-4" data-id="element-5585" data-mp="14fmpl7f5fcyd">
                <div className="flex text-green-500 mr-2" data-id="element-5586" data-mp="zga4ar3xedxw">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5587" data-mp="1w6sqvr6lvgp8" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5588" data-mp="1s5qstdofdaou">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5589" data-mp="1n4tan13f0gnc">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5590" data-mp="1i69l6qpm4mq8">
                Voorbereid zijn op de puppy die ik krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5591" data-mp="6r33flh01c9h">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5592" data-mp="3sqz4z1ekmh4s">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5593" data-mp="fe5q6xtmt776">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5594" data-mp="fddvdp7uzdhy">
          <div data-id="element-5595" data-mp="kbp5m122fq0p">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5596" data-mp="kb5ouno5j7o9">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5597" data-mp="ua4z2aokfbdd">
              <p data-id="element-5598" data-mp="2r3pyf2wytymr">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond gedrag vertoont dat je
                niet snapt.
              </p>
              <p data-id="element-5599" data-mp="182iupzjcuui9">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes mogen
                helpen hun hond beter te begrijpen. En wat ik keer op keer zie:
                de meeste frustratie komt niet door een 'slechte' hond. Het komt
                doordat baasjes en honden letterlijk twee verschillende talen
                spreken.
              </p>
              <p data-id="element-5600" data-mp="1mu159htg3wu8">
                Zodra je de hondentaal leert begrijpen, verdwijnt de frustratie.
                Je ziet wat je hond denkt, voelt en wilt. De strijd maakt plaats
                voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-5601" data-mp="20qxy1ot4jodr">
                Daarom werk ik uitsluitend met methodes gebaseerd op vertrouwen,
                veiligheid en echte communicatie. Geen dwang, geen straf. Alleen
                liefde en begrip.
              </p>
              <p data-id="element-5602" data-mp="6f9ok25nwe0r">
                Dit webinar is mijn manier om de hondentaal met zoveel mogelijk
                baasjes te delen. Omdat ik geloof dat elke hond en elk baasje de
                kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5603" data-mp="3l7fl2w1muclp">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5604" data-mp="3gbqe47na9tfd" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5605" data-mp="7ssnyfwpwu09">
        <div className="max-w-md mx-auto px-4" data-id="element-5606" data-mp="3tjtt9xrmu46">
          <div className="p-6 rounded-3xl w-full" data-id="element-5607" data-mp="3sqvmxcvhcxn">
            <div className="flex justify-center items-center" data-id="element-5608" data-mp="2slclaewvjqjq">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5609" data-mp="2siqh8p96zt69"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5610" data-mp="279nf42m28q27">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5611" data-mp="2c0nbn6r9p646">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5612" data-mp="2c2gl0tt9m4fv" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5613" data-mp="1oaszkrervlkz">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5614" data-mp="1sbcwpuzcip74">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5615" data-mp="14q186l57gtef">
            <p className="mb-2" data-id="element-5616" data-mp="1iosidwgy5uxa">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5617" data-mp="1dpfvjbq2snup">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5618" data-mp="26g67ltjsxae1" />
    </div>;
}